import router from "./router";
import { getPageTitle, getToken } from "@/utils/auth";
import store from "@/store";
import { getUser } from "@/api";
import { handleAccessReporting } from "@/utils";

router.beforeEach(async (to, _from, next) => {
  document.title = getPageTitle(to.meta.title);

  handleAccessReporting(to);

  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/auth/login") {
      next("/");
    } else {
      const hasUser = !!store.state.user?.user?.id;

      if (hasUser) {
        next();
      } else {
        try {
          const result = await getUser({ id: 0 });

          store.dispatch("user/setUser", result.data);

          next({ ...to, replace: true });
        } catch (error) {
          await store.dispatch("user/logout");

          // 获取用户失败也放行
          next();
        }
      }
    }
  } else {
    // 没有token，也可以访问其他页面
    next();
  }
});
